const initialState = {
	roles: "",
	user: {},
	screenPermissions: [],
	selectedFranchise: {},
};

const mutations = {
	setUser(state, data) {
		state.user = data;
	},
	setRoles(state, data) {
		state.roles = data;
	},
	setScreenPermissions(state, data) {
		state.screenPermissions = data;
	},
	setSelectedFranchise(state, data) {
		state.selectedFranchise = data
	}
};

const actions = {
	storeUserDetail({ commit }, data) {
		commit('setUser', data)
	}
};

const getters = {
	getUserDetails(state) {
		return state.user;
	},
};

export default {
	mutations,
	actions,
	state: initialState,
	getters
};
